import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const editQuizRequest = (value, userId, token) => {
  const url = apiURl + "users/survey/edit";

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ id: userId, userSurveyStatus: value }),
  };
  return fetchAndReturn(url, parameters);
};

export { editQuizRequest };
